import React from 'react';
import HeroSection from '../sections/HeroSection';
import PortfolioSection from '../sections/PortfolioSection';
import SkillsSection from '../sections/SkillsSection';

const Home = () => {
  return (
    <>
      <HeroSection />
      <PortfolioSection />
      <SkillsSection />
    </>
  );
};

export default Home;
